import { useMemo, useState, useCallback } from 'react';

type ErrorDictionary = Record<string, boolean>;

export const useDataGridError = () => {
  const [isEditing, setIsEditing] = useState(false);
  const [errorDictionary, setErrorDictionary] = useState<ErrorDictionary>({});

  const hasError = useMemo(() => {
    return Object.values(errorDictionary).some(Boolean);
  }, [errorDictionary]);

  const changeErrorDictionary = useCallback((updates: ErrorDictionary) => {
    setErrorDictionary((prev) => ({
      ...prev,
      ...updates,
    }));
  }, []);

  const handleEditing = useCallback(() => {
    setIsEditing((prev) => (hasError ? true : !prev));
  }, [hasError]);
  return {
    errorDictionary,
    changeErrorDictionary,
    handleEditing,
    isEditing,
    hasError,
    setIsEditing
  };
};
